export default __webpack_public_path__ + "static/media/mail.275ae67f.mp4";